import {byId} from './commons'

(function(exports) {

  function show(button: HTMLButtonElement, id: string): boolean {
    const input = byId<HTMLInputElement>(id, 'input')
    const hidden = input.type.toLowerCase() === 'password'
    input.type = hidden ? 'text' : 'password'
    button.setAttribute('data-show', '' + (!hidden))
    return false
  }

  const module = exports.password || {}
  exports.password = { ...module, show }

})(window['nam'] || (window['nam'] = {}))